import React, { useState } from "react";
import { Link } from "react-router-dom";
import SiteFooter from "../components/layout/SiteFooter";
import SiteNavbar from "../components/layout/SiteNavbar";
import { CONTACT_EMAILS } from "../components/layout/siteContactConfig";

const CONTACT_DETAILS = [
    {
        label: "Direccion",
        value: "Cerrito 1050 Piso 9, CABA, Argentina",
    },
    {
        label: "WhatsApp",
        value: "+54 9 11-2387-9118",
        href: "https://wa.me/5491123879118",
    },
];

const CONTACT_EMAIL_ITEMS = [
    {
        area: "Institucional",
        email: CONTACT_EMAILS.default,
    },
    {
        area: "Educativo",
        email: CONTACT_EMAILS.educativo,
    },
    {
        area: "Servicios empresariales",
        email: CONTACT_EMAILS.servicios,
    },
    {
        area: "Marketing, eventos y FISP TV",
        email: CONTACT_EMAILS.marketing,
    },
];

const INITIAL_FORM = {
    nombre: "",
    organizacion: "",
    email: "",
    area: "",
    mensaje: "",
};

function handleContactSubmit() {}

export default function Contacto() {
    const [formData, setFormData] = useState(INITIAL_FORM);

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFormData((currentData) => ({
            ...currentData,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        handleContactSubmit(formData);
    };

    return (
        <div className="contact-page">
            <SiteNavbar />

            <main className="site-static-page">
                <section className="site-static-hero">
                    <div className="site-static-inner">
                        <div className="site-static-breadcrumb">
                            <Link to="/">Inicio</Link>
                            <span>/</span>
                            <span>Contacto</span>
                        </div>
                        <h1>Contacto</h1>
                        <p>
                            Ponete en contacto con nosotros vía mail o Whatsapp, o llena el siguiente formulario.
                        </p>
                    </div>
                </section>

                <section className="site-static-section">
                    <div className="site-static-inner contact-page-grid">
                        <div className="contact-page-card contact-page-details">
                            {CONTACT_DETAILS.map((item) => (
                                <div key={item.label} className="contact-page-block">
                                    <p className="contact-page-label">{item.label}</p>
                                    <p className="contact-page-value">
                                        {item.href ? (
                                            <a href={item.href}>{item.value}</a>
                                        ) : (
                                            item.value
                                        )}
                                    </p>
                                </div>
                            ))}

                            <div className="contact-page-block">
                                <p className="contact-page-label">Mails</p>
                                <div className="contact-page-mail-list">
                                    {CONTACT_EMAIL_ITEMS.map((item) => (
                                        <p key={item.email} className="contact-page-mail-item">
                                            <span>{item.area}</span>
                                            <a href={`mailto:${item.email}`}>{item.email}</a>
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <form className="contact-page-card contact-page-form" onSubmit={handleSubmit}>
                            <div className="contact-page-form-head">
                                <h2>Escribinos</h2>
                            </div>

                            <div className="contact-page-form-grid">
                                <div className="contact-page-field">
                                    <label htmlFor="contacto-nombre">Nombre y apellido</label>
                                    <input
                                        id="contacto-nombre"
                                        name="nombre"
                                        type="text"
                                        value={formData.nombre}
                                        onChange={handleChange}
                                        placeholder="Ej: Maria Gonzalez"
                                    />
                                </div>

                                <div className="contact-page-field">
                                    <label htmlFor="contacto-organizacion">Organizacion</label>
                                    <input
                                        id="contacto-organizacion"
                                        name="organizacion"
                                        type="text"
                                        value={formData.organizacion}
                                        onChange={handleChange}
                                        placeholder="Empresa, institucion o area"
                                    />
                                </div>

                                <div className="contact-page-field">
                                    <label htmlFor="contacto-email">Email</label>
                                    <input
                                        id="contacto-email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="nombre@correo.com"
                                    />
                                </div>

                                <div className="contact-page-field">
                                    <label htmlFor="contacto-area">Area</label>
                                    <select
                                        id="contacto-area"
                                        name="area"
                                        value={formData.area}
                                        onChange={handleChange}
                                    >
                                        <option value="">Selecciona un area</option>
                                        <option value="institucional">Institucional</option>
                                        <option value="educativo">Educativo</option>
                                        <option value="servicios">Servicios</option>
                                        <option value="fisp-tv">FISP TV</option>
                                    </select>
                                </div>

                                <div className="contact-page-field">
                                    <label htmlFor="contacto-mensaje">Mensaje</label>
                                    <textarea
                                        id="contacto-mensaje"
                                        name="mensaje"
                                        rows="5"
                                        value={formData.mensaje}
                                        onChange={handleChange}
                                        placeholder="Escribe tu mensaje"
                                    />
                                </div>
                            </div>

                            <button type="submit" className="contact-page-submit">
                                Enviar
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2.5"
                                    aria-hidden="true"
                                >
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </button>
                        </form>
                    </div>
                </section>
            </main>

            <SiteFooter />
        </div>
    );
}
